import { Injectable } from '@angular/core';

import { TwcPopupOptions, TwcPopupService } from '@topcon/twc-angular';

import { CreateJobSiteDialogComponent } from '../../components/create-site-dialog/create-job-site-dialog.component';

/**
 * This service manages the creation of the site popup
 */
@Injectable({ providedIn: 'root' })
export class CreateSiteService {
    constructor(private popupService: TwcPopupService) {}

    /**
     * Open the create site dialog
     */
    openSiteDialog(options?: TwcPopupOptions): void {
        this.popupService.open(CreateJobSiteDialogComponent, options || {});
    }
}
